import { ProductOffering } from '@context/contentful/query.ProductOffering'
import { AssetFields } from '@model'
import { RichTextData } from '@atoms'

export type ProductOfferingForReco = Pick<
  ProductOffering,
  | 'slug'
  | 'name'
  | 'marketingMessage'
  | 'trackingName'
  | 'legalInformation'
  | 'icon'
  | 'largeImage'
  | 'smallImage'
  | 'promotionalPrice'
  | 'promotionalPriceInfo'
> & { aaxProductId: string }

export interface RecommendationItem {
  title: string
  text: RichTextData
  rentalPreferred: boolean
  image: {
    title: string
    imageTags: Array<string>
    image: AssetFields
    alternateText: string
  }
  productOffering: ProductOfferingForReco
  promotion?: PromotionForReco
}

export type PromotionForReco = {
  title: string
  description: RichTextData
  aaxCampaignId: string
  promotionalPrice: string
}

export interface RecommendationQuery {
  data: {
    recommendationCollection: {
      items: RecommendationItem[]
    }
  }
}

export const RecommendationQueryName = 'egshop-recommendation'
